var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 89.764C37.5 89.764 72.1111 72.4584 72.1111 46.5001V16.2154L37.5 3.23621L2.88892 16.2154V46.5001C2.88892 72.4584 37.5 89.764 37.5 89.764Z",
    fill: "#ADE2C2",
    stroke: "#5AC484",
    strokeWidth: 5.03571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7327 42.6919C19.2131 42.2671 18.5446 42.0451 17.861 42.0703C17.1774 42.0954 16.5289 42.366 16.0451 42.8277C15.5614 43.2895 15.2779 43.9084 15.2515 44.5609C15.2251 45.2135 15.4577 45.8517 15.9027 46.3477L32.2005 61.9048L61.89 34.6539C62.4086 34.1724 62.7058 33.5141 62.7159 32.8238C62.7262 32.1332 62.4486 31.4671 61.9443 30.9721C61.44 30.4768 60.7502 30.1932 60.0269 30.1836C59.3037 30.1738 58.6058 30.4388 58.0871 30.9203L32.3636 54.7486L19.7327 42.6919Z",
    fill: "#5AC484",
    stroke: "#5AC484",
    strokeWidth: 1.28224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldDone);
export default __webpack_public_path__ + "static/media/shield-done.d3907d8d.svg";
export { ForwardRef as ReactComponent };